import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/http/http.service';
import { LoaderService } from '../services/loader/loader.service';
import { FADE_IN } from '../util/animations/animation';
interface ParamsData {
  drawingId: string
}

/**
 * This component is used to show the winning tickets and for the particular drawing
 */
@Component({
  selector: 'app-winner-landing-page',
  templateUrl: './winner-landing-page.component.html',
  styleUrls: ['./winner-landing-page.component.scss'],
  animations: [FADE_IN]
})
export class WinnerLandingPageComponent implements OnInit {

  showLoader = false;
  paramsData: ParamsData;
  accessToken = "";
  practiceLogoUrl = 'https://www.carecognitics.com/wp-content/uploads/2018/10/icon.png';

  drawingDetails: any = {};
  awardRuleDeatils: any = {};
  winners: any = [];
  rewards = [];
  ticketBox: any = {
    loaderMsg: '',
    successMsg: '',
    failMsg: ''
  }
  
  constructor(private httpService: HttpService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private loader: LoaderService) {}

  ngOnInit() {
    this.loader.progressLoader.subscribe(state => {
      this.showLoader = state;
    })
    this.getParams();
  }

   /**
   * This function is use to read the params from the url
   */
  getParams() {
    this.paramsData = this.activeRoute.snapshot.queryParams as ParamsData;
    this.loader.show('progress');
    if (this.paramsData.drawingId) {
      this.getDrawing(this.paramsData.drawingId)
    }else{
      this.loader.hide('progress');
      this.router.navigateByUrl('**');
    } 
  }

/**
 * This function is used to get the drawing details by using drawing Id
 * @param drawingId 
 */
  getDrawing(drawingId) {
    const url = `drawing/${drawingId}`;

    this.httpService.get_landing_page(url)
      .subscribe((response: any) => {
        this.drawingDetails = response;
        this.awardRuleDeatils = this.drawingDetails.awardRule[0];

        if(this.drawingDetails.runStatus === 'Users Notified'){
          this.getWinningTickets()
        }else{
          console.log("the winner is not declared yet");
        }
        
        this.loader.hide('progress');
      },
        () => {
          this.loader.hide('progress');
        })
  }

  /**
   * This function is used to get the winning tickets for particular drawing
   */
  getWinningTickets() {
      this.loader.show('progress');
      this.httpService.get(`reward/win/${this.paramsData.drawingId}`)
        .subscribe((response: any) => {
          this.loader.hide('progress');
          this.winners = response;
        }, () => {
          this.loader.hide('progress');
        })
  }

  /**
   * This function is used to create the winner title
   * @param drawing 
   */
  getWinnerTitle(drawing){
    const singular = drawing.numberOfWinners>1? 'are' : 'the'
    return `Congratulations to ${singular} ${drawing.numberOfWinners} lucky winners out of ${drawing.numberOfTickets} tickets and ${drawing.numberOfParticipants} participants.`
  }

}